"use client";
import { useRef } from "react";



export default function Logos() {
  const brands: string[] = [
    "Power Corporation",
    "Concordia University",
    "McGill University",
    "TD Bank",
    "CIBC Bank",
    "Shaare Zion Synagog",
    "Pratt Building Appartments",
    "Bureau en Gros",
    "Bombardier",
    "Oxford Properties",
    "Domtar",
    "Moranda Technology Centre",
    "The Bay",
    "Eaton’s",
    "Canada Cement Building",
    "Pyrogenesis",
    "A.A.C. Inc",
    "Holiday Inn Hotel",
    "Olco Petroleum",
    "Sacred Heart School",
    "Priory School",
    "Queen of Angels Academy",
    "Bulmer House Residence",
    "Stanley Towers",
    "Imperial House",
    "Madicap Regency",
    "La Cité",
    "Prime Properties",
    "Gilette Wilson Lofts",
    "Monit",
    "Rockcliffe Appartments",
    "Ace Properties",
    "Sir Winston Churchill Pub",
    "Thursday’s",
    "Wing Noodles",
    "Westmount Place",
    "Manoir Mont-Royal",
    "Tour Urbain",
    "3 Amigos",
    "Stein & Stein",
    "Empress Cultural Centre",
    "Axia Property Management",
    "Landmark Properties",
    "Rosdev",
    "Le Doray",
    "Fard Investments",
    "Martini Realties",
  ];

  // Split brands into 3 rows as evenly as possible
  const rowCount = 3;
  const brandsPerRow = Math.ceil(brands.length / rowCount);
  const rows: string[][] = Array.from({ length: rowCount }, (_, rowIdx) =>
    brands.slice(rowIdx * brandsPerRow, (rowIdx + 1) * brandsPerRow),
  );

  const carouselRef = useRef<HTMLDivElement>(null);

  const handleScrollRight = () => {
    if (carouselRef.current) {
      const container = carouselRef.current;
      container.scrollBy({
        left: container.offsetWidth / 1.2,
        behavior: "smooth",
      });
    }
  };

  return (
    <div className="mx-auto lg:ml-28 px-5 md:px-8 lg:px-0 py-12 lg:py-16">
      <h2 className="ml-2 mb-8 flex justify-start text-2xl font-light sm:text-3xl bg-gradient-to-b from-foreground to-muted-foreground text-transparent bg-clip-text">
        <span className="lg:text-[2.35rem] font-normal">
          Our clients include...
        </span>
      </h2>
      <div className="w-full flex items-center gap-2">
        <div
          className="overflow-x-auto flex-1"
          ref={carouselRef}
          style={{ scrollBehavior: "smooth" }}
        >
          <div className="min-w-[680px]">
            <div className="flex flex-col gap-2">
              {rows.map((row, rowIdx) => (
                <ul
                  key={rowIdx}
                  className="flex flex-nowrap gap-4 mb-1"
                  style={{ minWidth: "100%" }}
                >
                  {row.map((brand, idx) => (
                    <li
                      className="flex-shrink-0 px-4 py-2 rounded-md bg-card text-card-foreground text-base sm:text-lg font-normal hover:bg-accent/50 transition-colors duration-150"
                      key={idx}
                    >
                      <span>{brand}</span>
                    </li>
                  ))}
                </ul>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
